<template>
  <div v-if="vShow">
    <div
      :class="{ show: aShow }"
      class="modal-backdrop fade modal-stack"
      style="z-index: 1039"
      @click="hide"
    ></div>

    <div
      :class="{ show: aShow }"
      class="modal fade"
      style="z-index: 1040; display: block"
      tabindex="-1"
      @click.self="hide"
    >
      <div
        :class="{ 'modal-lg': isLarge }"
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="exampleModalLabel" class="modal-title">
              {{ $t(title) }}
            </h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
              @click="hide"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div style="max-height: 80vh;overflow-y: scroll">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PopModal",
  props: {
    title: String,
    isLarge: Boolean
  },
  data() {
    return {
      vShow: false,
      aShow: false
    };
  },
  methods: {
    show() {
      this.vShow = true;
      // 在界面初始化的时候就是这个样式的话，就不会做过渡动画 所以间隔一帧再修改样式
      requestAnimationFrame(() => (this.aShow = true));
    },
    hide() {
      this.aShow = false;
      setTimeout(() => {
        this.vShow = false;
      }, 150);
    }
  }
};
</script>
